import * as xlsx from 'xlsx';

export const xlsxExport = (headers: any[], data: any[][], title: string) => {
  const ws = xlsx.utils.aoa_to_sheet([headers].concat(data));
  const wb = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(wb, ws, 'Sheet 1');
  xlsx.writeFile(wb, title);
};
